import { helper } from '@ember/component/helper';

import { eq } from 'rise-ui/utils/choice.js';

export default helper(function indexOfHelper([ needle, haystack ]) {
  return haystack?.findIndex(hay => eq(hay, needle)) ?? -1;
});
